import { useState, type FormEvent } from 'react';
import { ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Button } from '../ui/core';
import { Field, TextInput } from '../ui/form';
import { AramisMark } from '../layout/Brand';

export function Login({ mode }: { mode: 'login' | 'setup' }) {
  const { login, setup } = useAuth();
  const [form, setForm] = useState({ login: '', password: '', setupCode: '', name: '', phone: '', email: '' });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [message, setMessage] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const set = (k: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement>) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true); setErrors({}); setMessage(null);
    try {
      if (mode === 'login') await login(form.login.trim(), form.password);
      else await setup({ setupCode: form.setupCode.trim(), name: form.name, phone: form.phone, email: form.email || undefined, password: form.password });
    } catch (err) {
      if (err instanceof ApiError) { setMessage(err.message); setErrors(err.fields ?? {}); } else setMessage('ارتباط با سرور برقرار نشد.');
    } finally { setBusy(false); }
  };

  return (
    <main className="grid min-h-dvh place-items-center px-4 py-10">
      <form onSubmit={submit} className="w-full max-w-[380px]" noValidate>
        <AramisMark className="mb-6 size-10 text-text" />
        <h1 className="text-xl font-medium">{mode === 'login' ? 'ورود به پنل آرامیس' : 'راه‌اندازی فروشگاه'}</h1>
        <p className="mt-1 text-muted">{mode === 'login' ? 'با شماره موبایل یا ایمیل کاری وارد شوید.' : 'حساب مالک فروشگاه را بسازید. کد راه‌اندازی در گزارش سرور چاپ شده است.'}</p>
        <div className="mt-6 flex flex-col gap-4">
          {mode === 'setup' ? (<>
            <Field label="کد راه‌اندازی" error={errors.setupCode} htmlFor="sc"><TextInput id="sc" ltr autoComplete="one-time-code" value={form.setupCode} onChange={set('setupCode')} invalid={!!errors.setupCode} /></Field>
            <Field label="نام شما" error={errors.name} htmlFor="nm"><TextInput id="nm" autoComplete="name" value={form.name} onChange={set('name')} invalid={!!errors.name} /></Field>
            <Field label="شماره موبایل" error={errors.phone} htmlFor="ph"><TextInput id="ph" ltr inputMode="tel" autoComplete="tel" placeholder="09121234567" value={form.phone} onChange={set('phone')} invalid={!!errors.phone} /></Field>
            <Field label="ایمیل (اختیاری)" error={errors.email} htmlFor="em"><TextInput id="em" ltr type="email" autoComplete="email" value={form.email} onChange={set('email')} /></Field>
          </>) : (
            <Field label="موبایل یا ایمیل" error={errors.login} htmlFor="lg"><TextInput id="lg" ltr autoComplete="username" autoFocus value={form.login} onChange={set('login')} invalid={!!errors.login} /></Field>
          )}
          <Field label="رمز عبور" error={errors.password} hint={mode === 'setup' ? 'حداقل ۸ نویسه' : undefined} htmlFor="pw">
            <TextInput id="pw" ltr type="password" autoComplete={mode === 'login' ? 'current-password' : 'new-password'} value={form.password} onChange={set('password')} invalid={!!errors.password} />
          </Field>
          {message && <p role="alert" className="rounded-control bg-danger-soft px-3 py-2 text-[13px] text-danger">{message}</p>}
          <Button variant="primary" type="submit" loading={busy} className="mt-1 w-full">{mode === 'login' ? 'ورود' : 'ساخت حساب و ورود'}</Button>
        </div>
      </form>
    </main>
  );
}
